import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '@morningstar/shared/base/base-component';
import { ReportExplanationIconDialogComponent } from './report-explanation-icon-dialog/report-explanation-icon-dialog.component';
import { ReportExplanationIconService } from './report-explanation-icon.service';
import { ReportExplanation } from 'apps/wsg/src/app/admin/report-explanation/report-explanation';
import { ReportExplanationIconSelectors } from './report-explanation-icon.selectors';
import { select } from '@morningstar/shared/operators';

@Component({
  selector: 'wsg-report-explanation-icon',
  templateUrl: './report-explanation-icon.component.html',
  styleUrls: ['./report-explanation-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportExplanationIconComponent extends BaseComponent {

  // == CONSTANTS ======================================================================

  @Input() size = '';

  @Input()
  set name(name: string){
    this.reportExplanationIconService.getReportExplanation(name);
  }

  component = ReportExplanationIconDialogComponent;

  // == STATE ==========================================================================

  state$ = this.reportExplanationIconService.state$;

  // == INTERMEDIATE ===================================================================

  reportExplanation$ = this.state$.pipe(
    select<ReportExplanation>(ReportExplanationIconSelectors.reportExplanation)
  );

  // == LIFE CYCLE =====================================================================

  constructor(private reportExplanationIconService: ReportExplanationIconService) {
    super(reportExplanationIconService);
  }

  getClass(size: string) {
    switch (size) {
      case 'small':
        return 'small-icon';
      case 'md-small':
        return 'md-small-icon';
      default:
        return '';
    }
  }
}
